<template>
    <div class="wl-container">
        <div class="updateGuide" v-if="updateGuide"></div>
        <div class="wl-content-container">
            <div class="wl-info">
                <div class="block enpar">
                    <img class="left block-icon" :src="PartnerIcon" />
                    <div class="right">
                        <div class="name">{{ ownerName ? ownerName : '&nbsp;' }}</div>
                        <div class="position">{{ $t('PAGE_KPMG_TEAM_OWNER') }}</div>
                    </div>
                </div>
                <div class="divider"></div>
                <div class="block engmanager">
                    <img class="left block-icon" :src="ManagerIcon" />
                    <div class="right">
                        <div class="name">{{ managerName ? managerName : '&nbsp;' }}</div>
                        <div class="position">{{ $t('PAGE_KPMG_TEAM_MANGER') }}</div>
                    </div>
                </div>
                <div class="divider"></div>
                <div class="block siteadmin">
                    <img class="left block-icon" :src="SiteAdminIcon" />
                    <div class="right" style="width: 100%">
                        <div class="name">
                            <el-tooltip
                                class="item"
                                effect="dark"
                                :content="adminNameList(adminName)"
                                placement="top-end"
                                :disabled="!showAdminTooltip"
                            >
                                <span ref="adminNameList" class="name-text" @mouseover="calcShowAdminTooltip">{{
                                    adminNameList(adminName) ? adminNameList(adminName) : '&nbsp;'
                                }}</span>
                            </el-tooltip>

                            <div @click="editName('admin')" class="editicon">
                                <i class="el-icon-edit" />
                                <span>{{ $t('COMMON_EDIT') }}</span>
                            </div>
                        </div>
                        <div class="position">{{ $t('PAGE_KPMG_TEAM_ADMIN') }}</div>
                    </div>
                </div>
            </div>
            <!-- 搜索框 -->
            <div class="wl-search-bar">
                <div class="wl-left">
                    <el-input
                        :placeholder="
                            $t('TABLE_HEADER_EMAIL_StaffNo') +
                            ',' +
                            $t('TABLE_HEADER_EMAIL_StaffName') +
                            ',' +
                            $t('TABLE_HEADER_EMAIL_ProfitCenter')
                        "
                        v-model="searchContent"
                        clearable
                        @keyup.enter.native="searchUser"
                        maxlength="100"
                        class="input-with-select"
                    >
                        <i slot="suffix" class="el-input__icon el-icon-search" @click="searchUser" style="cursor: pointer" />
                    </el-input>
                </div>

                <div class="wl-right">
                    <select-ad ref="selectAdd" class="select-ad-cls" :api="selectFromAD" :filter="adFilter" :onAdd="onAddAccount">
                    </select-ad>
                    <el-button class="wl-green svg-btn" @click="onPatchRoleClick('role')"  :disabled="patchSerRole.showCheck">
                        <img src="@/assets/img/icon-batchsetting.svg" width="100%" class="btn-icon" />
                        {{ $t('patch_set_role') }}
                    </el-button>
                    <el-button class="wl-green svg-btn" @click="onPatchRoleClick('delete')" :disabled="patchSerRole.showCheck">
                        <img src="@/assets/img/icon-batchdeletion.svg" width="100%" class="btn-icon" />
                        {{ $t('patch_delete_user') }}
                    </el-button>
                    <!-- 下载导入模板 -->
                    <el-button
                        @click="download"
                        class="wl-green"
                        style="margin-right: 10px;"
                        icon="el-icon-download">
                        {{$t('COMMON_DOWNLOAD_TEMP')}}
                    </el-button>
                    <!-- 导入 -->
                    <el-upload class="template-uploader"
                                action="url"
                                :http-request="uploadFiles"
                                :show-file-list="false"
                                :on-success="handleAvatarSuccess"
                                :before-upload="beforeAvatarUpload">
                        <el-button class="wl-green svg-btn"><img src="@/assets/img/icon-import.svg" width="100%" class="btn-icon"/>{{$t('COMMON_IMPORT')}}
                        </el-button>
                    </el-upload>
                </div>
            </div>

            <!-- 表格 -->

            <div :class="['table-container-wrapper', patchSerRole.showCheck ? 'show-table-bottom-operate' : '', {'guide-table':updateGuide}]">
                 <div
                    v-if="updateGuide"
                    class="updateGuideTitle"
                    :style="{ height: `${updateGuideTitleHeight}px`, right: '100px' }"
                >
                    <div class="updateGuideTip" :style="{ top: `${updateGuideTitleHeight + 10}px` }">
                        <div class="margin-bottom-10" v-html="$t('KP_NOTICE')"></div>
                        <el-button @click="gotItClick" class="guide-btn">{{ $t('gotIt') }}</el-button>
                    </div>
                </div>
                <el-table v-loading="loading" :data="data" height="100%" border stripe
                    :cell-class-name="noRoleCell" :header-cell-class-name="updateGuideClass"
                 @selection-change="onTableCheckChange">
                    <el-table-column v-if="this.patchSerRole.showCheck" type="selection" width="55"> </el-table-column>
                    <el-table-column type="index" align="center" width="70"> </el-table-column>

                    <el-table-column prop="staffNo"  :label="$t('TABLE_HEADER_EMAIL_StaffNo')" show-overflow-tooltip> </el-table-column>

                    <el-table-column prop="userName" :min-width="110" :label="$t('TABLE_HEADER_EMAIL_StaffName')"> </el-table-column>

                    <el-table-column prop="profitCenter" :min-width="130"  :label="$t('TABLE_HEADER_EMAIL_ProfitCenter')"> </el-table-column>

                    <el-table-column prop="email" :min-width="180"  :label="$t('TABLE_HEADER_EMAIL_Email')"> </el-table-column>
                    <!-- <el-table-column prop="position" :width="150" :label="$t('TABLE_HEADER_EMAIL_Position')"> </el-table-column> -->
                 
                    <el-table-column prop="ifContact" width="180" align="center" :label="$t('TABLE_HEADER_KPifContact')">
                        <template slot-scope="scope">
                            <el-switch
                                v-model="scope.row.ifContact"
                                @change="changeIfContact(scope.row)"
                                active-color="#3879eb"
                                inactive-color="#a9acaf"
                            ></el-switch>
                        </template>
                    </el-table-column>
                    <el-table-column prop="ifAdmin" width="220" align="center" :label="$t('TABLE_HEADER_KPifAdmin')">
                        <template slot-scope="scope">
                            <el-switch
                                v-model="scope.row.ifAdmin"
                                @change="changeIfAdmin(scope.row)"
                                active-color="#3879eb"
                                inactive-color="#a9acaf"
                            ></el-switch>
                        </template>
                    </el-table-column>
                    <el-table-column prop="ifConf" width="180" align="center" :label="$t('TABLE_HEADER_KPifConf')">
                        <template slot-scope="scope">
                            <el-switch
                                v-model="scope.row.ifConf"
                                @change="changeIfConf(scope.row)"
                                active-color="#3879eb"
                                inactive-color="#a9acaf"
                            ></el-switch>
                        </template>
                    </el-table-column>


                    <el-table-column width="180" fixed="right">
                          <template slot="header">
                            <span style="color:#fd349c; margin-right: 5px; vertical-align: center">*</span>{{ $t('TABLE_HEADER_Access_Level') }}
                            <el-tooltip class="item" effect="dark" placement="top" >
                                  <div slot="content" v-html="$t('TABLE_HEADER_KP_Access_Level_Tip')"
                                  ></div>
                                <i class="el-icon-warning" style="color:#fd349c; margin-right: 5px"></i>
                            </el-tooltip>
                        </template>
                        <template slot-scope="scope">
                            <KPAccessLevelSelect :initData="scope.row.accessType" @change="(val)=>handleAccessLevelChange(scope.row,val)"/>
                        </template>
                    </el-table-column>

                    <el-table-column width="200" fixed="right" :label="$t('TABLE_HEADER_CLIENT_ENTITIES')">
                         <template slot="header">
                            <span style="color:#fd349c; margin-right: 5px; vertical-align: center">*</span>{{ $t('TABLE_HEADER_CLIENT_ENTITIES') }}
                        </template>
                        <template slot-scope="scope">
                            <el-select :key="scope.$index+'null'" v-if="!scope.row.accessType" style="width:100%" value=""></el-select>
                           <el-select v-else-if="scope.row.accessType==='ALL'" style="width:100%" disabled :value="$t('All_ENTITIES')"></el-select>
                             <select-tree v-else-if="scope.row.accessType!=='ALL'&&scope.row.refresh" size="mini" :data="orgData" style="width:100%" :filterable="true" 
                             :check-strictly="true" :defaultCheckedKeys="scope.row.clientEntityIds" @visible-change="(list)=>handleVisibleChange(scope.row,list)"
                                :defaultExpandAll="true" :defaultProps="defaultProps" >
                            </select-tree>
                         </template>
                    </el-table-column>

                    <el-table-column prop="action" width="100" fixed="right" align="center" :label="$t('COMMON_DELETE')">
                        <template slot-scope="scope">
                            <i class="el-icon-delete wl-icon-delete" @click="onDeleteAccount(scope.row)"></i>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <!-- 表格底部的操作按钮：批量设置角色 -->
            <div v-if="patchSerRole.showCheck" class="wl-btn-container">
                <el-button @click="cancelPatchRole" class="cancel-btn" :loading="patchSerRole.loading">
                    {{ $t('btn_cancel') }}
                </el-button>
                <el-button
                    @click="beginPatchDelete"
                    class="wl-green"
                    v-if="patchSerRole.showCheck && patchSerRole.mode == 'delete'"
                    :disabled="patchSerRole.users.length <= 0"
                    :loading="patchSerRole.loading"
                >
                    {{ $t('patch_delete_user') }}
                </el-button>
                <el-button
                    @click="beginPatchRole"
                    class="wl-green"
                    v-if="patchSerRole.showCheck && patchSerRole.mode == 'role'"
                    :disabled="patchSerRole.users.length <= 0"
                    :loading="patchSerRole.loading"
                >
                    {{ $t('patch_set_role') }}
                </el-button>
            </div>

            <!-- 分页 -->
            <el-pagination
                class="wl-pagination"
                :current-page="pagination.pageNum"
                :page-size="pagination.pageSize"
                @current-change="onCurrentPageChange"
                @size-change="onSizeChange"
                :page-sizes="[10, 50, 100]"
                layout="prev, pager, next, sizes, total"
                :total="pagination.total"
            >
            </el-pagination>
        </div>
        <AdUserInfo
            v-if="addVisible"
            :nameFlag="nameFlag"
            :isArray="isArray"
            :saveLoading="btnLoading"
            :initData="initData"
            :onCancel="toggleAddVisible"
            :onAdd="saveAdUser"
        />
        <kpPatchRoleDialog :visible="patchRoleVisible" :data="orgData" :allNodes="allNodes" @submit="batchSetRole" @close='patchRoleVisible=false'/>
        <el-dialog :title="$t('COMMON_ADD')" :visible.sync="dialogVisible" width="30%">
            <span v-if="!alertVisible" style="margin: 10px; word-break: normal"> {{ $t('msg_submit_sure') }} <br /><br /> </span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="closeDialog()" class="cancel-btn">{{ $t('btn_cancel') }}</el-button>
                <el-button type="primary" @click="addAccount" class="wl-green" :disabled="alertVisible" :loading="addingStaff">{{
                    $t('btn_confirm')
                }}</el-button>
            </span>
            <div style="background-color: #fef0f0; color: #f56c6c" v-if="alertVisible">
                <i class="el-icon-circle-close" />
                <span v-html="$t(alertI18N)" />
            </div>
        </el-dialog>
    </div>
</template>
<script>
import SelectAd from '@/components/common/selectAd'
import bus from '@/components/common/bus'
import AdUserInfo from './aduserInfo-add'
import API from '@/api'

import { loading, deleteConfirm, UserInput, isIE } from '@/utils'
import { mapGetters } from 'vuex'

import ManagerIcon from '@/assets/img/manager.png'
import PartnerIcon from '@/assets/img/partner.png'
import SiteAdminIcon from '@/assets/img/SiteAdministrator.png'
import KPAccessLevelSelect from "./kpAccessLevelSelect.vue"
import selectTree from "./selectTree.vue"
import kpPatchRoleDialog from "./kpPatchRoleDialog.vue"


export default {
    components: {
        SelectAd,
        AdUserInfo,
        KPAccessLevelSelect,
        selectTree,
        kpPatchRoleDialog
    },
    data() {
        return {
            patchRoleVisible:false,
            ManagerIcon,
            PartnerIcon,
            SiteAdminIcon,

            data: [],
            ownerName: '',
            managerName: '',
            adminName: [],
            pagination: {
                pageNum: 1,
                pageSize: 10,
                total: 0
            },
            loading: false,
            searchContent: '',
            btnLoading: false,
            initData: '',
            addVisible: false,
            nameFlag: '',
            isArray: false,
            roleList: [],
            siteOwner: {},
            siteManger: {},
            siteAdmin: [],
            dialogVisible: false,
            alertVisible: false,
            alertI18N: '',
            addingStaff: false,
            patchSerRole: {
                showCheck: false,
                showDialog: false,
                users: [],
                roles: [],
                loading: false,
                mode: '' // role|delete
            },
            showAdminTooltip: false,
             defaultProps: {
                children: 'childEntity',
                label: 'entityName'
            },
            orgData:[],
            filterText:"",
            switchFlag: 0,
            allNodes:[],
            updateGuide:false,
            updateGuideTitleHeight:0,
            fileParams: new FormData(),
        }
    },

     computed: {
        ...mapGetters('common', {
            getUser: 'getUser',
            getSite: 'getSite'
        }),
      
    },
    async mounted() {
        this.siteId = this.getSite.siteId
        await this.getRoleList()
        await this.getSiteInfo()
        await this.getStaffList()
        this.getClientPermission();
        this.getBehavior();
    },
   
    methods: {
        handleVisibleChange(row,list) {
            const clientEntityIds = list.map(v=>v.id);
            if(row.clientEntityIds.length === clientEntityIds.length&& 
                row.clientEntityIds.every(v=>clientEntityIds.includes(v))) return;

            if(list.length===this.allNodes.length&&row.accessType==='SPECIFIC'){
                this.$confirm(this.$t("ROLE_CHANGE_TIP"), this.$t('COMMON_TIP'), {
                confirmButtonText: this.$t('btn_confirm'),
                cancelButtonText: this.$t('btn_cancel'),
                type: 'warning'
                }).then(()=>{
                    row.accessType = "ALL";
                    this.changeRole({...row,clientEntityIds});
                    return 
                }).catch(action=>{
                    if(action ==='cancel'){
                        this.$set(row,"clientEntityIds",row.clientEntityIds);
                        this.allNodes.forEach(v=>v.checked = false)
                        row.refresh = false;
                        this.$nextTick(()=>this.$set(row,"refresh",true))
                    }
                })
               return
            }
            this.changeRole({...row,clientEntityIds});
        },
        handleAccessLevelChange(row,val){
            row.accessType =val;
            if(val ==="SPECIFIC"){
                row.clientEntityIds=[];
                this.allNodes.forEach(e=>e.checked= false)
            }
            if(val ==="ALL"){
                this.changeRole(row);
            }
        },
        batchSetRole({clientEntityIds,accessType}){
            const params= { siteId: this.getSite.siteId,
                    userIds: this.patchSerRole.users.map(v=>v.userId),
                    accessType:accessType,
                    entityIdList:clientEntityIds,
                    userType: "1"}
            API.kpTMember.updateKPMemberRole(params).then((res) => {
                    if (res.code == '1') {
                        this.$message.success(this.$t('msg_success'))
                        this.patchRoleVisible = false;
                        this.getStaffList()
                    } else {
                        this.$message.error(this.$t(res.code))
                    }
                    this.patchSerRole.showCheck = false
                })
        },
        getClientPermission(row) {
            row = row || {roleIdList: []};
            const params = {
                siteId: this.siteId,
                roleId: row.roleIdList[0],
            }
            API.kpUserRole.queryKPMGPermission(params).then(res => {
                if (res.code == '1') {
                    this.orgData =[ Object.assign({}, {row: row}, res.data)]
                    this.getAllPermissions();
                }else {
                    this.$message.error(this.$t(res.code));
                }
            })
        },
        getAllPermissions(){
            const stack = [...this.orgData]
            this.allNodes = [this.orgData]
            while(stack.length) {
                const node = stack.pop()
                if (node.childEntity) {
                    node.childEntity.forEach(item => {
                        stack.push(item)
                        this.allNodes.push(item)
                    })
                }
                
            }
        },
        calcShowAdminTooltip() {
            if (!this.$refs || !this.$refs.adminNameList) return false

                
            let parentWidth = this.$refs.adminNameList.parentNode.offsetWidth
            let contentWidth = this.$refs.adminNameList.offsetWidth
            // 判断是否开启tooltip功能
            if (contentWidth > parentWidth) {
                this.showAdminTooltip = false
                // return false
            } else {
                this.showAdminTooltip = true
                // return true;
            }
        },
        beginPatchDelete() {
            this.$confirm(this.$t('batchDeleteUserConfirm'), {
                confirmButtonText: this.$t('btn_confirm2'),
                cancelButtonText: this.$t('btn_cancel'),
                type: 'error',
                cancelButtonClass: 'cancel-btn',
                confirmButtonClass: 'wl-green',
                center: false,
                dangerouslyUseHTMLString: true,
            }).then(() => {
                this.patchSerRole.loading = true
                const params = {
                    siteId: this.siteId,
                    userIds: this.patchSerRole.users.map((v) => `${v.userId}`)
                }
                API.kpTMember
                    .deleteMembers(params)
                    .then((res) => {
                        if (res.code == '1') {
                            this.$message.success(this.$t('msg_success'))
                            this.pagination.pageNum = 1
                            this.getStaffList()
                            this.getSiteInfo()
                            this.patchSerRole = {
                                showCheck: false,
                                showDialog: false,
                                users: [],
                                roles: [],
                                loading: false,
                                mode: ''
                            }
                        } else {
                            this.$message.error(this.$t(res.code))
                        }
                    })
                    .catch((e) => {
                        console.error(e)
                        this.$message.error(this.$t('SYS_USER_003'))
                    })
                    .finally(() => {
                        this.patchSerRole.loading = false
                    })
            })
        },
        
        onPatchDeleteClick() {
            this.patchSerRole.showCheck = true
            this.patchSerRole.users = []
        },
        // 批量授予角色，下拉框选择变化
        onPatchSetRoleChange(e) {},
        // 提交批量授予角色
        commitPatchSetRole() {
            const params = {
                siteId: this.getSite.siteId,
                userIds: this.patchSerRole.users.map((v) => `${v.userId}`),
                roleIds: this.patchSerRole.roles.map((v) => `${v}`),
                userType: "1"
            }
            this.patchSerRole.loading = true
            API.kpTMember
                .updateKPMemberRole(params)
                .then((res) => {
                    if (res.code == '1') {
                        this.$message.success(this.$t('msg_success'))
                        this.patchSerRole.showDialog = false
                        this.patchSerRole.roles = []
                        this.getStaffList()
                        this.patchSerRole = {
                            showCheck: false,
                            showDialog: false,
                            users: [],
                            roles: [],
                            loading: false,
                            mode: ''
                        }
                    } else {
                        this.$message.error(this.$t(res.code))
                    }
                })
                .catch((e) => {
                    console.error(e)
                    this.$message.error(this.$t('SYS_USER_003'))
                })
                .finally(() => {
                    this.patchSerRole.loading = false
                })
        },
        // 批量授予角色 打开窗口
        beginPatchRole() {
            this.patchSerRole.showDialog = true
            this.patchSerRole.roles = []
             this.patchRoleVisible = true;
        },
        // 批量授予角色，取消
        cancelPatchRole() {
            this.patchSerRole.showCheck = false
        },
        onTableCheckChange(e) {
            this.patchSerRole.users = e
        },
        // 批量授予角色
        onPatchRoleClick(mode) {
            this.patchSerRole.showCheck = true
            this.patchSerRole.mode = mode
        },
        closeDialog() {
            this.dialogVisible = false
            this.alertVisible = false
        },
        changeRole(data) {
            const params = {
                siteId: this.getSite.siteId,
                userIds: [`${data.userId}`],
                // roleIds: data.roleIdList
                accessType:data.accessType,
                entityIdList:data.clientEntityIds,
                userType: "1"
            }
            API.kpTMember.updateKPMemberRole(params).then((res) => {
                if (res.code == '1') {
                    this.$message.success(this.$t('msg_success'))
                    this.getStaffList()
                } else {
                    this.$message.error(this.$t(res.code))
                }
            })
        },
         noRoleCell({row,  columnIndex}) {
            if ((columnIndex === 9 && (row.clientEntityIds ===null || !row.clientEntityIds.length)) 
                || columnIndex === 8&&!row.accessType) {
            return 'red'
            }
        },
        async getRoleList() {
            try {
                const params = {
                    siteId: this.siteId,
                    pageNum: 1,
                    pageSize: 99999
                }
                const { data, code } = await API.kpUserRole.queryKPMGRoleList(params)
                if (code == '1') {
                    this.roleList = data.records
                } else {
                    this.$message.error(this.$t(code))
                }
            } catch (e) {
            } finally {
            }
        },
        toggleAddVisible() {
            this.addVisible = !this.addVisible
        },
        saveAdUser(list) {
            if (this.nameFlag === 'owner') {
                const params = {
                    siteId: this.siteId,
                    kpmgUser: {
                        ...list[0]
                    },
                    siteFlag: this.siteFlag
                }
                API.kpTMember.updateSiteOwner(params).then((res) => {
                    if (res.code == '1') {
                        this.getSiteInfo()
                        this.$message.success(this.$t('msg_success'))
                        this.addVisible = !this.addVisible
                        this.getStaffList()
                    } else {
                        this.$message({
                            message: this.$t(res.code),
                            type: 'error',
                            dangerouslyUseHTMLString: true
                        })
                    }
                })
            }
            if (this.nameFlag === 'manager') {
                const params = {
                    siteId: this.siteId,
                    kpmgUser: {
                        userAccount: list[0].userAccount,
                        userName: list[0].userName,
                        staffNo: list[0].staffNo,
                        email: list[0].email,
                        phone: list[0].phone,
                        position: list[0].position,
                        profitCenter: list[0].profitCenter
                    }
                }
                API.kpTMember.updateSiteManager(params).then((res) => {
                    if (res.code === '1') {
                        this.getSiteInfo()
                        this.$message.success(this.$t('msg_success'))
                        this.addVisible = !this.addVisible
                        this.getStaffList()
                    } else {
                        this.$message.error(this.$t(res.code))
                    }
                })
            }
            if (this.nameFlag === 'admin') {
                const params = {
                    siteId: this.siteId,
                    kpmgUserList: list,
                    siteFlag: this.siteFlag
                }
                API.kpTMember.updateSiteAdmin(params).then((res) => {
                    if (res.code == '1') {
                        this.getSiteInfo()
                        this.$message.success(this.$t('msg_success'))
                        this.addVisible = !this.addVisible
                        this.getStaffList()
                    } else {
                        if (res.code === 'ROLE_003') {
                            const startIndex = res.errDetails.msg ? res.errDetails.msg.indexOf('[') : null
                            const endIndex = res.errDetails.msg ? res.errDetails.msg.indexOf(']') : null
                            const security_admin =
                                res.errDetails.msg && startIndex && startIndex !== -1 && endIndex && endIndex !== -1
                                    ? res.errDetails.msg.substring(startIndex + 1, endIndex)
                                    : null
                            this.$message({
                                dangerouslyUseHTMLString: true,
                                type: 'error',
                                message: this.$t('ROLE_003', { security_admin: security_admin })
                            })
                        } else {
                            this.$message({
                                message: this.$t(res.code),
                                type: 'error',
                                dangerouslyUseHTMLString: true
                            })
                        }
                    }
                })
            }
        },
        editName(flag) {
            this.nameFlag = flag
            if (flag === 'admin') {
                //站点管理员
                this.isArray = true
                this.initData = this.siteAdmin
            } else if (flag === 'owner') {
                //项目合伙人
                this.isArray = false
                this.initData = this.siteOwner
            } else {
                //项目管理员
                this.isArray = false
                this.initData = this.siteManger
            }
            this.addVisible = !this.addVisible
        },
        async getStaffList() {
            try {
                this.loading = true
                const params = {
                    siteId: this.siteId,
                    pageNum: this.pagination.pageNum,
                    pageSize: this.pagination.pageSize,
                    queryParam: this.searchContent,
                    userType: '1' //string 3 代表compoent/ 1代表member
                }
                const { data, code } = await API.kpTMember.queryMemberList(params)
                if (code == '1' && data.memberList) {
                    this.loading = false
                    this.data = data.memberList.records.map(v=>{
                        v.clientEntityIds = v.clientEntityIds || [];
                        v.refresh = true;
                        return v;
                    });
                    this.pagination.total = data.memberList.total
                }
                if (code !== '1') {
                    this.$message.error(this.$t(code))
                }
            } catch (e) {
            } finally {
                this.loading = false
            }
        },
        async getSiteInfo() {
            try {
                const params = {
                    siteId: this.siteId
                }
                const { data, code } = await API.kpTMember.querySiteInfo(params)
                if (code == '1' && data) {
                    if (data.siteOwner) {
                        this.ownerName = data.siteOwner.userName
                    }
                    if (data.siteManager) {
                        this.managerName = data.siteManager.userName
                    }
                    this.adminName = data.siteAdminList
                    this.siteAdmin = data.siteAdminList
                    this.siteOwner = data.siteOwner
                    this.siteManger = data.siteManager
                    this.siteFlag = data.siteFlag
                } else {
                    this.$message.error(this.$t(code))
                }
            } catch (e) {
            } finally {
            }
        },
        searchUser: _.debounce(
            function () {
                if (this.searchContent && !UserInput.reg1.test(this.searchContent)) {
                    this.$message.error(this.$t('ILLEGAL_USER_INPUT_02'))
                    return
                }
                this.onCurrentPageChange(1)
            },
            500,
            { leading: true }
        ),
        onSizeChange(size) {
            this.pagination.pageSize = size
            this.pagination.pageNum = 1
            this.getStaffList()
        },
        onCurrentPageChange(current) {
            this.pagination.pageNum = current
            this.getStaffList()
        },
        changeIfContact(data) {
            const params = {
                siteId: this.siteId,
                userId: data.userId,
                ifContact: data.ifContact
            }
            API.kpTMember.kpIsContact(params).then((res) => {
                if (res.code == '1') {
                    this.$message.success(this.$t('msg_success'))
                    // this.getStaffList()
                } else {
                    this.$message.error(this.$t(res.code))
                }
            })
        },
        changeIfConf(data) {
            const params = {
                siteId: this.siteId,
                userId: data.userId,
                ifConf: data.ifConf
            }
            API.kpTMember.kpConf(params).then((res) => {
                if (res.code == '1') {
                    this.$message.success(this.$t('msg_success'))
                    // this.getStaffList()
                } else {
                    this.$message.error(this.$t(res.code))
                }
            })
        },
        changeIfAdmin(data) {
            const params = {
                siteId: this.siteId,
                userId: data.userId,
                ifAdmin: data.ifAdmin
            }
            API.kpTMember.kpAdmin(params).then((res) => {
                if (res.code == '1') {
                    this.$message.success(this.$t('msg_success'))
                    // this.getStaffList()
                } else {
                    this.$message.error(this.$t(res.code))
                }
            })
        },

        changeIfkpMember(data) {
            const params = {
                siteId: this.siteId,
                userId: data.userId,
                ifKpMember: data.ifKpMember
            }
            API.kpTMember.changeKpMember(params).then((res) => {
                if (res.code == '1') {
                    this.$message.success(this.$t('msg_success'))
                    // 手动刷新整个页面，更新目录
                    bus.$emit('updateSidebar', this.getUser.userId === data.userId && data.ifKpMember)
                } else {
                    this.$message.error(this.$t(res.code))
                }
            })
        },

        onAddAccount(list) {
            this.list = list
            this.dialogVisible = true
            this.alertVisible = false
        },
        addAccount() {
            if (this.addingStaff) {
                return
            }
            const params = {
                siteId: this.siteId,
                kpmgUser: { ...this.list[0] },
                siteFlag: this.siteFlag,
                userType: '1' //string 3 代表compoent/ 1代表member
            }
            this.addingStaff = true
            API.kpTMember
                .bindMembers(params)
                .then((res) => {
                    if (res.code == '1') {
                        this.$message.success(this.$t('msg_success'))
                        this.dialogVisible = false
                        this.getStaffList()
                    } else {
                        this.alertVisible = true
                        this.alertI18N = res.code
                    }
                })
                .catch((e) => {
                    console.error(e)
                    this.$message.error(this.$t('SYS_USER_003'))
                })
                .finally(() => {
                    this.addingStaff = false
                })
        },
        onDeleteAccount(row) {
            const params = {
                siteId: this.siteId,
                userIds: [`${row.userId}`]
            }
            this.$confirm(this.$t('batchDeleteUserConfirm'), {
                confirmButtonText: this.$t('btn_confirm2'),
                cancelButtonText: this.$t('btn_cancel'),
                type: 'error',
                cancelButtonClass: 'cancel-btn',
                confirmButtonClass: 'wl-green',
                center: false,
                dangerouslyUseHTMLString: true,
            }).then(() =>
                API.kpTMember.deleteMembers(params).then((res) => {
                    if (res.code == '1') {
                        this.$message.success(this.$t('msg_success'))
                        this.getStaffList()
                        this.getSiteInfo()
                    } else {
                        this.$message.error(this.$t(res.code))
                    }
                })
            )
        },
        adminNameList(list) {
            return _.map(list, (v) => v.userName).join('; ')
        },
        selectFromAD: (params) => API.system.adList(params),
        adFilter: (v) => Object.assign({}, v, { label: v.userName + '  (' + v.profitCenter + ')', value: v.staffNo }),
        getBehavior() {
            API.common.queryBehavior().then((res) => {
                if (res.code === '1') {
                    this.updateGuide = res.data.kpmgMemberNoticeFlag === 0
                    this.changeGuideTitleHeight()
                } else {
                    this.$message.error(this.$t(res.code))
                }
            })
        },
         updateGuideClass({ row, column, rowIndex, columnIndex }) {
            if (
                this.updateGuide && columnIndex == 8
            ) {
                return 'updateGuideFixedHeaderTitle'
            }
            return ''
        },
      changeGuideTitleHeight() {
            setTimeout(() => {
                this.updateGuideTitleHeight = document.getElementsByClassName('el-table__header-wrapper')[0].clientHeight
            }, 500)
        },
        gotItClick() {
            let param = {
                kpmgMemberNoticeFlag: 1
            }
            API.common.updateBehavior(param).then((res) => {
                if (res.code === '1') {
                    this.updateGuide = false
                } else {
                    this.$message.error(this.$t(res.code))
                }
            })
        },
        handleAvatarSuccess(res, file) {},
        beforeAvatarUpload(file) {
            const isExcel =
                file.type === 'application/vnd.ms-excel' ||
                file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
                file.type === 'image/png'
            const isLt2M = file.size / 1024 / 1024 < 5

            if (!isExcel) {
                this.$message.error(this.$t('import_file_type_error'))
            }
            if (!isLt2M) {
                this.$message.error(this.$t('import_file_size_error'))
            }
            return isExcel && isLt2M
        },
        uploadFiles(item) {
            this.fileParams = new FormData()
            this.fileParams.append('siteId', this.siteId)
            this.fileParams.append('file', item.file)
            this.fileParams.append('siteFlag', this.siteFlag)
            this.fileParams.append('userType', '1')
            this.upload()
        },
        async upload() {
            let service = loading()
            try {
                service.upload()
                const {data, code, errDetails} = await API.kpTMember.importKPMembers(this.fileParams)
                if (code == '1') {
                this.$message.success(this.$t('msg_success'))
                this.getStaffList()()
                } else {
                this.$message.error(this.$t(code))
                }
            } catch (e) {
            } finally {
                service.close()
            }
        },
        async download() {
            let service = loading()
            try {
                service.download()
                const res = await API.kpTMember.downloadKPMembersTemplate()
                if (/application\/json/.test(res.type)) {

                let reader = new FileReader()
                reader.onload = e => {
                    if (e.target.readyState === 2) {
                    let resJson = {}
                    resJson = JSON.parse(e.target.result)
                    this.$message.error({duration: 5000, message: this.$t(resJson.code)})
                    }
                }
                reader.readAsText(res)
                } else if (/application\/octet-stream/.test(res.type)) {

                let blob = new Blob([res])
                if (isIE()) {
                    navigator.msSaveBlob(blob, 'KptMemberTemplate.xlsx')
                } else {
                    let url = window.URL.createObjectURL(blob)
                    let link = document.createElement('a')
                    link.style.display = 'none'
                    link.href = url
                    link.setAttribute('download', 'KptMemberTemplate.xlsx')
                    document.body.appendChild(link)
                    link.click()
                }
                }
            } catch (e) {
            } finally {
                service.close()
            }
        },
    },
    
}
</script>

<style scoped>
::v-deep .el-table .el-table__body tr td.el-table__cell.red {
    background-color: rgba(255, 227, 230, 1);
  }
.mr_10{
    margin-right:10px;
}
.mr_25{
    margin-left:25px;
}
.desc{
    color:#636363;
    font-weight:400;
}
::v-deep .label-hidden .el-radio__label{
    display: none;
}

.wl-container {
    height: 100%;
    background: #eff1f5;
    padding: 22px;
}

.wl-content-container {
    background: #fff;
    height: 100%;
    padding: 22px 22px 16px 22px;
    border-radius: 8px;
}

.wl-info {
    width: 100%;
    height: 70px;
    border-bottom: 1px solid #e3e4e6;
    display: flex;
    flex-direction: row;
    align-items: center;
}
.wl-info .block {
    display: flex;
    flex-direction: row;
    align-items: center;
    /* width: 230px; */
    height: 100%;
}
.wl-info .siteadmin {
    width: 750px;
}
.wl-info .block .left {
    width: 40px;
    height: 40px;
}
.wl-info .block .right {
    /* width: 190px; */
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-left: 10px;
}
.wl-info .siteadmin .right {
    width: 610px;
}

.wl-info .block .right .name {
    font-size: 14px;
    color: #253248;
    width: 98%;
    display: flex;
    flex-direction: row;
    align-items: center;
}
.wl-info .block .right .name .name-text {
    max-width: 90%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.wl-info .block .right .name .editicon {
    margin-left: 5px;
    color: #3879eb;
    cursor: pointer;
    width: 60px;
}
.wl-info .block .right .position {
    font-size: 12px;
    color: #babcbf;
}

.wl-info .divider {
    width: 2px;
    height: 40%;
    background-color: #eeeeef;
    margin-left: 50px;
    margin-right: 50px;
}

.info-row {
    height: 33px;
    line-height: 33px;
    font-size: 14px;
    display: flex;
    flex-direction: row;
    align-items: center;
}

.border-left {
    padding-left: 10px;
    margin-left: 10px;
    border-left: 1px solid #e3e4e6;
}
.info-row .site-admin {
    display: flex;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: center;
}
.info-row .label-text {
    color: #a9acaf;
    margin-right: 10px;
}
.info-row .text {
    color: #333333;
    max-width: calc(100% - 55px);
    overflow: hidden;
    font-weight: bold;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.info-row i {
    cursor: pointer;
    color: #3879eb;
    font-weight: 500;
    font-size: 16px;
    vertical-align: center;
}

.el-icon-edit {
    margin-left: 4px;
}
.wl-search-bar {
    height: 60px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.wl-left,
.wl-right {
    display: flex;
    justify-content: flex-start;
    justify-items: center;
}
.select-ad-cls {
    margin-right: 10px;
}
.input-with-select {
    margin-right: 12px;
    width: 290px;
}

.table-container-wrapper {
    height: calc(100% - 48px - 114PX);
    position: relative;
}
.table-container-wrapper.show-table-bottom-operate {
    height: calc(100% - 98px - 94px);
}
.wl-btn-container {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 50px;
}

 .updateGuideTitle {
    position: absolute;
    background-color: white;
    height: 45px;
    z-index: 2003;
    border: 2px solid #3879eb !important;
    border-radius: 10px;
    width: 370px;
}

.margin-bottom-10 {
    margin-bottom: 10px;
}
.guide-btn {
    float: right;
    color: #3879eb;
}

.updateGuideTitle .updateGuideTip {
    z-index: 2003;
    background-color: #3879eb;
    padding: 20px;
    color: white;
    position: absolute;
    left: 0;
    top: 42px;
    width: 370px;
    border-radius: 10px;
    text-align: left;
    font-size: 14px;
    line-height: normal;
}
::v-deep .guide-table .el-table__fixed-header-wrapper{
    z-index: 2003;
}
.updateGuide {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 0.5;
    background: #000;
    z-index: 100;
}
::v-deep .guide-table .el-table .el-table__header tr:nth-child(1) th {
   border: none;
}
</style>
